import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {useUnlockChoiceCta} from "../../auth/hooks/use_unlock_choice_cta";
import {startRegistrationFlow} from "../../auth/state/registration_flow_slice";
import {UnlockChoiceEntryPoint} from "../../auth/types/UnlockChoiceEntryPoint";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch} from "../../store/hooks";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";
import {openVendorReportModal} from "../state/vendor_detail_slice";
import {hitGTMDeveloperReportClick} from "../tracking/hit_gtm_developer_report";

interface IUseVendorReportButtonOptions {
    propertyId?: number;
    offerId?: number;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

const VENDOR_REPORT_BUTTON_TEXT = "Raport o deweloperze";

export function useVendorReportButton(vendorId: number, options?: IUseVendorReportButtonOptions) {
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();
    const {startUnlockChoice} = useUnlockChoiceCta();

    const handleClick = () => {
        hitGTMDeveloperReportClick();
        if (options?.offerId != null) {
            trackAmplitudeButtonClick({
                buttonName: "download_developer_report",
                value: "download_developer_report",
                buttonCategory: options?.propertyId ? "property_page" : "investment_page",
                itemId: options.offerId,
                propertyId: options?.propertyId
            });
        }
        if (hasPhoneVerified) {
            if (
                startUnlockChoice({
                    kind: "vendor_report",
                    vendorId,
                    offerId: options?.offerId,
                    propertyId: options?.propertyId,
                    amplitudePlacement: options?.amplitudePlacement
                })
            ) {
                return;
            }

            dispatch(openVendorReportModal({vendorId}));
        } else {
            dispatch(
                startRegistrationFlow({
                    isUserLoggedIn: isUserAuthenticated,
                    hasCompleteProfile,
                    hasPhoneVerified,
                    userSource: UserSource.VENDOR_REPORT_BUTTON,
                    titleVariant: AuthModalVariant.DOWNLOAD_REPORT,
                    entryCtaLabel: VENDOR_REPORT_BUTTON_TEXT,
                    gtmSourceSection: "Rejestracja z przycisku pobrania raportu o deweloperze",
                    propertyId: options?.propertyId,
                    offerId: options?.offerId,
                    vendorId,
                    amplitudePlacement: options?.amplitudePlacement,
                    unlockChoiceEntryPoint: UnlockChoiceEntryPoint.VENDOR_REPORT
                })
            );
        }
    };

    return {
        handleClick,
        buttonText: VENDOR_REPORT_BUTTON_TEXT
    };
}
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {useUnlockChoiceCta} from "../../auth/hooks/use_unlock_choice_cta";
import {startRegistrationFlow} from "../../auth/state/registration_flow_slice";
import {UnlockChoiceEntryPoint} from "../../auth/types/UnlockChoiceEntryPoint";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch} from "../../store/hooks";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";
import {openVendorReportModal} from "../state/vendor_detail_slice";
import {hitGTMDeveloperReportClick} from "../tracking/hit_gtm_developer_report";

interface IUseVendorReportButtonOptions {
    propertyId?: number;
    offerId?: number;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

const VENDOR_REPORT_BUTTON_TEXT = "Raport o deweloperze";

export function useVendorReportButton(vendorId: number, options?: IUseVendorReportButtonOptions) {
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();
    const {startUnlockChoice} = useUnlockChoiceCta();

    const handleClick = () => {
        hitGTMDeveloperReportClick();
        if (options?.offerId != null) {
            trackAmplitudeButtonClick({
                buttonName: "download_developer_report",
                value: "download_developer_report",
                buttonCategory: options?.propertyId ? "property_page" : "investment_page",
                itemId: options.offerId,
                propertyId: options?.propertyId
            });
        }
        if (hasPhoneVerified) {
            if (
                startUnlockChoice({
                    kind: "vendor_report",
                    vendorId,
                    offerId: options?.offerId,
                    propertyId: options?.propertyId,
                    amplitudePlacement: options?.amplitudePlacement
                })
            ) {
                return;
            }

            dispatch(openVendorReportModal({vendorId}));
        } else {
            dispatch(
                startRegistrationFlow({
                    isUserLoggedIn: isUserAuthenticated,
                    hasCompleteProfile,
                    hasPhoneVerified,
                    userSource: UserSource.VENDOR_REPORT_BUTTON,
                    titleVariant: AuthModalVariant.DOWNLOAD_REPORT,
                    entryCtaLabel: VENDOR_REPORT_BUTTON_TEXT,
                    gtmSourceSection: "Rejestracja z przycisku pobrania raportu o deweloperze",
                    propertyId: options?.propertyId,
                    offerId: options?.offerId,
                    vendorId,
                    amplitudePlacement: options?.amplitudePlacement,
                    unlockChoiceEntryPoint: UnlockChoiceEntryPoint.VENDOR_REPORT
                })
            );
        }
    };

    return {
        handleClick,
        buttonText: VENDOR_REPORT_BUTTON_TEXT
    };
}
